import { useRef } from 'react'

import { InformationCardProps } from './type'
import Icon from '~/components/Icon'
import useClickOutside from '~/hooks/useClickOutside'

import {
  ComponentStructure,
  Content,
  HeaderStructure,
  Title,
  CloseButtonStructure
} from './styles'

const InformationCard = ({
  children,
  title,
  spacingClass = 'small',
  isOpen = false,
  close,
  style
}: InformationCardProps) => {
  const refContentElement = useRef<HTMLDivElement>(null)

  useClickOutside(refContentElement, close)

  if (!isOpen) return null

  return (
    <ComponentStructure>
      <Content
        {...{ style }}
        ref={refContentElement}
        spacingClass={spacingClass}
      >
        <HeaderStructure spacingClass={spacingClass}>
          <Title spacingClass={spacingClass}>{title}</Title>
          <CloseButtonStructure
            spacingClass={spacingClass}
            onClick={() => close()}
          >
            <Icon iconName='Close' icSize={spacingClass} icColor='_006BFF' />
          </CloseButtonStructure>
        </HeaderStructure>
        {children}
      </Content>
    </ComponentStructure>
  )
}

export default InformationCard
